<template>
<div class="flex w-full -pr-4 sm:-pr-6 md:-mr-8 justify-around">
  <div v-show="showOptions" class="w-1/3 -ml-4">
      <!--
        Slide-over panel, show/hide based on slide-over state.

        Entering: "transform transition ease-in-out duration-500 sm:duration-700"
          From: "translate-x-full"
          To: "translate-x-0"
        Leaving: "transform transition ease-in-out duration-500 sm:duration-700"
          From: "translate-x-0"
          To: "translate-x-full"
      -->
      <div class="h-full flex flex-col bg-white blue overflow-y-auto">
        <header class="space-y-1 py-6 px-4 bg-blue-700 sm:px-6">
          <div class="flex items-center justify-between space-x-3">
            <span class="text-lg leading-7 font-medium text-white">
              Light & Sound Report Options
            </span>
            <div class="h-7 flex items-center">
              <button @click="showOptions = false" aria-label="Close panel" class="text-blue-200 hover:text-white">
                <!-- Heroicon name: x -->
                <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
          </div>
          <div>
            <p class="text-sm leading-5 text-blue-300">
              Select your options below
            </p>
          </div>
        </header>
        <div class="relative flex-1 py-6 px-4 sm:px-6">
          <div class="flex items-center space-x-3">
            <toggle name="tippyToggle" v-model:value="showTippy"></toggle>
            <span id="toggleLabel">
              <span class="text-sm leading-5 font-medium text-gray-900">Toggle Definition Tooltip </span>
            </span>
          </div>
          <slot name="options">

          </slot>
        </div>
      </div>
    </div>
  <div :class="widthMain">
    <div class="flex justify-between w-full">
      <button @click="showOptions= !showOptions"
              class="inline-flex justify-center items-center ml-2 px-4 py-2 border-2 border-blue-200 text-md leading-5 font-sm
              font-sans rounded-md text-blue-700 bg-white hover:bg-blue-600 hover:text-white
              focus:outline-none focus:ring-blue-200 focus:border-blue-400 active:bg-blue-600"
      >
        {{showOptions ? 'Hide' : 'Show'}} Options
      </button>
      <span class="text-2xl">Light & Sound Report</span>
      <button @click="showDefinitions= !showDefinitions"
              class="inline-flex justify-center items-center ml-2 px-4 py-2 border-2 border-blue-200 text-md leading-5 font-sm
              font-sans rounded-md text-blue-700 bg-white hover:bg-blue-600 hover:text-white
              focus:outline-none focus:ring-blue-200 focus:border-blue-400 active:bg-blue-600"
      >
        {{showDefinitions ? 'Hide' : 'Show'}}  Definitions
      </button>
    </div>
      <slot>

      </slot>

      <div id="graphDiv" :style="graphHeight">

      </div>
    </div>
  <div v-show="showDefinitions" class="w-1/3 -mr-8">
      <!--
        Slide-over panel, show/hide based on slide-over state.

        Entering: "transform transition ease-in-out duration-500 sm:duration-700"
          From: "translate-x-full"
          To: "translate-x-0"
        Leaving: "transform transition ease-in-out duration-500 sm:duration-700"
          From: "translate-x-0"
          To: "translate-x-full"
      -->
        <div class="h-full flex flex-col bg-white blue overflow-y-auto">
            <header class="space-y-1 py-6 px-4 bg-blue-700 sm:px-6">
              <div class="flex items-center justify-between space-x-3">
                <span class="text-lg leading-7 font-medium text-white">
                  Light & Sound Report Definitions
                </span>
                <div class="h-7 flex items-center">
                  <button @click="showDefinitions = false" aria-label="Close panel" class="text-blue-200 hover:text-white">
                    <!-- Heroicon name: x -->
                    <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                </div>
              </div>
              <div>
              </div>
            </header>
            <div class="relative flex-1 py-6 px-4 sm:px-6">
              <!-- Replace with your content -->
              <sonicu-header class="pt-0 pb-3">
                Plot Definitions
              </sonicu-header>
              <ul class="list-disc text-base">
                <li><b>Light Min</b> : The lowest light measurement, in Lux, during the 5 minutes after the time displayed.</li>
                <li><b>Light Avg</b> : The average light measurement, in Lux, during the 5 minutes after the time displayed.</li>
                <li><b>Light Max</b> : The maximum light measurement, in Lux, during the 5 minutes after the time displayed.</li>
                <li><b>Light Threshold</b> : The Light High Threshold, in Lux, configured in the Alarm Profiles for Light devices.</li>
                <li><b>Sound Lmin</b> : The lowest sound pressure measurement, in dBA, during the 5 minutes after the time displayed.</li>
                <li><b>Sound Leq</b> : The logarithmic average sound pressure measurement, in dBA, during the 5 minutes after the time displayed.</li>
                <li><b>Sound Lmax</b> : The maximum sound pressure measurement, in dBA, during the 5 minutes after the time displayed.</li>
                <li><b>Sound Threshold</b> : The Sound High Threshold, in dBA, configured in the Alarm Profiles for Sound devices.</li>
              </ul>
              <sonicu-header class="pt-0 pb-3">
                Option Definitions
              </sonicu-header>
              <ul class="list-disc text-base">
                <li><b>High Light Threshold</b> : When a value (in Lux) is input into the lefthand box, the righthand box will display the percentage of time the Light Max readings were above this value.</li>
                <li><b>Low Light Threshold</b> : When a value (in Lux) is input into the lefthand box, the righthand box will display the percentage of time the Light Min readings were below this value.</li>
                <li><b>Target Light Threshold</b> : When a value (in Lux) is input into the lefthand box, the righthand box will display the percentage of time the Light Avg readings were within this value ± ‘Light Tolerance %’.</li>
                <li><b>Light Tolerance %</b> : The percent tolerance to apply to the Target Light Threshold calculation.</li>
                <li><b>High Sound Threshold</b> : When a value (in dBA) is input into the lefthand box, the righthand box will display the percentage of time the Sound Lmax readings were above this value.</li>
                <li><b>Low Sound Threshold</b> : When a value (in dBA) is input into the lefthand box, the righthand box will display the percentage of time the Sound Lmin readings were below this value.</li>
                <li><b>Target Sound Threshold</b> : When a value (in dBA) is input into the lefthand box, the righthand box will display the percentage of time the Sound Leq readings were within this value ± ‘Sound Tolerance %’.</li>
                <li><b>Sound Tolerance %</b> : The percent tolerance to apply to the Target Sound Threshold calculation.</li>
                <li><b>Sound Display Range (dBA)</b> : Adjust the lefthand value to set the minimum dBA on the graph; adjust the righthand value to set the maximum dBA on the graph.</li>
                <li><b>Lux Display Range (Lux)</b> : Adjust the lefthand value to set the minimum Lux on the graph; adjust the righthand value to set the maximum Lux on the graph.</li>
              </ul>
              <!-- /End replace -->
            </div>
          </div>
    </div>
  </div>
</template>

<script>
import tippy from "tippy.js";
import Toggle from "@/components/elements/toggle";
import SonicuHeader from "@/components/elements/SonicuHeader";

export default {
  name: "LightSoundReport",
  components: {SonicuHeader, Toggle},
  data(){
    return {
      showDefinitions: false,
      showOptions: false,
      tippyInstance: null,
      showTippy: true,
    }
  },
  mounted(){
    setTimeout(() => {
      this.enableTippy();
    }, 1000)
  },
  computed: {
    widthMain(){
      if(this.showOptions || this.showDefinitions){
        if(this.showOptions && this.showDefinitions){
          return 'w-1/3';
        }
        return 'w-2/3';
      }
      return 'w-full';
    },
    graphHeight(){
      let clientHeight = document.documentElement.clientHeight;
      clientHeight = clientHeight - 300;
      return "height: " + clientHeight.toString() + "px;"
    },
  },
  methods: {
    enableTippy(){
      this.tippyInstance = tippy('[data-tippy-content]');
    },
    disableTippy(){
      this.tippyInstance.forEach(instance => {
        instance.destroy();
      });
      this.tippyInstance.length = 0; // clear it
    },
  },
  watch:{
    showTippy(newVal){
      if(newVal === true){
        this.enableTippy();
      } else {
        this.disableTippy();
      }
    }
  }
}
</script>

<style scoped>

</style>